angular.module('impactx.company').controller('SupplierListCtrl',[
    '$scope',
    'CompanyService',
    'selectedListItems',
    'PartialDialogsService',
    SupplierListCtrl]);

function SupplierListCtrl($scope, CompanyService, selectedListItems, PartialDialogsService) {
    var self = this;

    PartialDialogsService.setCurrentList(PartialDialogsService.TYPE.COMPANY, "supplierlist");

    self.deleteCompany = function(data) {
        CompanyService.deleteCompany(selectedListItems.getFirstSelectedItem(), true, $scope, false, '/company/delete', 'supplierListCtrl');
    };

    CompanyService.setCompanyListActions(self, selectedListItems);

    var buttonDefinition = [
        {
            label: "companyData",
            linkFunction: self.getCompanyDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {
            label: "clientCompanyData",
            linkFunction: self.getClientCompanyDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {
            label: "relations",
            linkFunction: self.getCompanyRelationDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {
            label: "interface",
            linkFunction: self.getCompanyInterfaceDataLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'EditCompany'
        },
        {label: "delete", action: self.deleteCompany, condition: self.canDelete, process: 'EditCompany'}
    ];

    this.meta = {
        rowTemplate: 'modules/company/templates/supplierlist.row.tmpl.html',
        mainAction: {id: "new", link: "#/suppliercreation", icon: "mdi-plus"},
        isSelectAble: true,
        ctrl: this,
        endpoint: '/company/supplierlist',
        id: "supplierlist",
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function() {
        return this.meta;
    };
}